import { render, staticRenderFns } from "./read-only-column.vue?vue&type=template&id=fa3f1104&scoped=true"
import script from "./read-only-column.vue?vue&type=script&lang=js"
export * from "./read-only-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3f1104",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa3f1104')) {
      api.createRecord('fa3f1104', component.options)
    } else {
      api.reload('fa3f1104', component.options)
    }
    module.hot.accept("./read-only-column.vue?vue&type=template&id=fa3f1104&scoped=true", function () {
      api.rerender('fa3f1104', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/send-list-note/columns/read-only-column.vue"
export default component.exports